/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginRequestDto
 */
export interface LoginRequestDto {
    /**
     * 
     * @type {number}
     * @memberof LoginRequestDto
     */
    igvKennung?: number;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestDto
     */
    password?: string | null;
}

/**
 * Check if a given object implements the LoginRequestDto interface.
 */
export function instanceOfLoginRequestDto(value: object): value is LoginRequestDto {
    return true;
}

export function LoginRequestDtoFromJSON(json: any): LoginRequestDto {
    return LoginRequestDtoFromJSONTyped(json, false);
}

export function LoginRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'igvKennung': json['igvKennung'] == null ? undefined : json['igvKennung'],
        'password': json['password'] == null ? undefined : json['password'],
    };
}

export function LoginRequestDtoToJSON(json: any): LoginRequestDto {
    return LoginRequestDtoToJSONTyped(json, false);
}

export function LoginRequestDtoToJSONTyped(value?: LoginRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'igvKennung': value['igvKennung'],
        'password': value['password'],
    };
}

